export const MARKETS = ['SE','NL-BE','UK','US','AU','NO','GE','FR','DK','FI','CA']

export const MARKET_LABELS = {
  'SE':'Sweden','NL-BE':'Netherlands/Belgium','UK':'United Kingdom',
  'US':'United States','AU':'Australia','NO':'Norway',
  'GE':'Germany','FR':'France','DK':'Denmark','FI':'Finland','CA':'Canada'
}

export const ROLES = {
  owner: { label: 'Owner', color: '#0D1B2A', icon: '👑' },
  funnel_builder: { label: 'Funnel Builder', color: '#065F46', icon: '🔧' },
  creative_editor: { label: 'Creative Editor', color: '#5B21B6', icon: '🎨' },
  ad_copy_writer: { label: 'Ad Copy Writer', color: '#92400E', icon: '✍️' },
  ad_scheduler: { label: 'Ad Scheduler', color: '#991B1B', icon: '📅' },
  pending: { label: 'Pending', color: '#6B7280', icon: '⏳' },
  user:    { label: 'User',    color: '#1E40AF', icon: '👤' },
}

export const FUNNEL_STATUS = ['In Progress','Ready','Proofreading','On Hold','Cancelled']
export const CREATIVE_STATUS = ['In Progress','Ready','Revision Needed','Approved','Cancelled']
export const AD_COPY_STATUS = ['In Progress','Ready','Approved','Needs Revision','Cancelled']
export const CAMPAIGN_STATUS = ['Draft','Scheduled','Active','Paused','Completed','Cancelled']
export const AD_ACCOUNTS = ['[NOVA]','[ZEUS]','[ATLAS]','[TITAN]','[ORION]']
export const WHO_CREATES = ['Cris Kier','Alex Johnson','Maria Garcia','James Lee','Sophie Turner','David Kim']
export const EDITORS = ['Emma Wilson','Chris Brown','Aisha Patel',"Ryan O'Brien",'Zoe Martinez']
export const APPROVERS = ['Sarah Mitchell','Tom Nguyen','Lisa Chen','Omar Hassan','Julia Scott']

export const STATUS_COLORS = {
  'Ready': 'success', 'Approved': 'success', 'Active': 'success',
  'In Progress': 'info', 'Draft': 'info', 'Scheduled': 'info', 'Proofreading': 'info',
  'Needs Revision': 'warning', 'Revision Needed': 'warning', 'Paused': 'warning', 'On Hold': 'warning',
  'Cancelled': 'danger', 'Completed': 'success',
}
